export default "__VITE_ASSET__Cu1Jd5P3__"